"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultCheckboxContainerStyle = exports.getDefaultCheckboxStyle = exports.getDefaultRadioItemStyle = exports.getDefaultListItemStyle = exports.getDefaultMenuStyle = exports.getDefaultToggleButtonStyle = exports.getDefaultSelectStyle = exports.getDefaultOptionStyle = void 0;
function getDefaultOptionStyle(sel, item) {
    return {
        color: sel.isItemValid(item) ? "rgb(131, 131, 131)" : "red",
        minHeight: "18px",
        alignSelf: "center",
        border: "0px none rgb(131, 131, 131)",
        font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif",
        outline: "rgb(131, 131, 131) none 0px",
    };
}
exports.getDefaultOptionStyle = getDefaultOptionStyle;
function getDefaultSelectStyle(sel) {
    var always = {
        color: "black",
        height: "30px",
        border: "1px solid #b4b4b4",
        borderRadius: "3px",
        font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif",
        outline: "rgb(131, 131, 131) none 0px",
        padding: "1px 30px 0px 10px",
    };
    var isSelectedItemValid = sel.isItemValid(sel.selectedItem);
    if (!isSelectedItemValid && sel.disabled) {
        return __assign(__assign({}, always), { background: "lightgray", color: "red", border: "none" });
    }
    else if (!isSelectedItemValid) {
        return __assign(__assign({}, always), { color: "red" });
    }
    else if (sel.disabled) {
        return __assign(__assign({}, always), { background: "lightgray", color: "darkgray", border: "none" });
    }
    return __assign({}, always);
}
exports.getDefaultSelectStyle = getDefaultSelectStyle;
function getDefaultToggleButtonStyle(selector) {
    return __assign({ width: "162px", alignItems: "center", background: "white", color: "black", height: "30px", whiteSpace: "nowrap", border: "1px solid #b4b4b4", borderRadius: "3px", font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif", outline: "rgb(131, 131, 131) none 0px", padding: "1px 5px 0px 14px", textAlign: "right" }, buttonElementStyles({
        isSelectedItemValid: selector.isItemValid(selector.selectedItem),
        locked: selector.disabled,
    }));
}
exports.getDefaultToggleButtonStyle = getDefaultToggleButtonStyle;
function getDefaultMenuStyle() {
    return {
        position: "absolute",
        display: "block",
        background: "white",
        border: "1px solid #bbb",
        listStyle: "none",
        margin: 0,
        padding: 0,
        zIndex: 100,
    };
}
exports.getDefaultMenuStyle = getDefaultMenuStyle;
function getDefaultListItemStyle(sel, item) {
    return {
        color: !sel.isItemValid(item) ? "color: red" : "rgb(131, 131, 131)",
        minHeight: "18px",
        alignSelf: "center",
        border: "0px none rgb(131, 131, 131)",
        font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif",
        outline: "rgb(131, 131, 131) none 0px",
        padding: "0.2em 0.5em",
        cursor: "default",
    };
}
exports.getDefaultListItemStyle = getDefaultListItemStyle;
function getDefaultRadioItemStyle(sel, item) {
    var isItemValid = sel.isItemValid(item);
    return {
        cursor: isItemValid ? "pointer" : "not-allowed",
        display: "inline-block",
        marginRight: "10px",
        padding: "10px",
        border: sel.selectedItem === item ? "2px solid " + (isItemValid ? "#39f" : "red") : "2px solid transparent",
        color: isItemValid ? "black" : "grey",
        // ${(p: RadioGroupItemProps) =>
        //   p.isItemValid ? "&:hover { background: #39f; color: white;" : ""}
    };
}
exports.getDefaultRadioItemStyle = getDefaultRadioItemStyle;
function buttonElementStyles(_a) {
    var isSelectedItemValid = _a.isSelectedItemValid, locked = _a.locked;
    if (isSelectedItemValid === false && locked) {
        return {
            background: "lightgray",
            color: "red",
            border: "none",
        };
    }
    else if (isSelectedItemValid === false) {
        return { color: "red" };
    }
    else if (locked) {
        return {
            background: "lightgray",
            color: "darkgray",
            border: "none",
        };
    }
    return {};
}
function getDefaultCheckboxStyle(selector) {
    return {
        marginTop: "6px",
        position: "relative",
        backgroundColor: "#ccc",
        width: "22px",
        height: "22px",
        background: selector.isTrueItem ? "red" : "green",
    };
}
exports.getDefaultCheckboxStyle = getDefaultCheckboxStyle;
function getDefaultCheckboxContainerStyle() {
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
    };
}
exports.getDefaultCheckboxContainerStyle = getDefaultCheckboxContainerStyle;
//# sourceMappingURL=default-styles.js.map